// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"c1da127c","955":"f438d1ba"}[chunkId] + ".chunk.css";
};